module.exports = "<div>{{address.addressLine1}}</div>\r\n<div>{{address.addressLine2}}</div>\r\n<div>{{address.addressLine3}}</div>\r\n<div>{{address.postalCode}}</div>\r\n<div>{{address.city}}</div>\r\n<div>{{address.state}}</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/platform/widgets/inputs/templates/address-summary-PostCodeBeforeCity.html
// module id = 406
// module chunks = 0